import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { OverlayRef } from '@angular/cdk/overlay';
import { isString } from '@pct-ts/typeguard';

@Component({
  selector: 'pct-feature-image-native-image-overlay-content',
  templateUrl: './image-overlay-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    ::ng-deep {
      .dark-backdrop {
        background-color: rgba(0, 0, 0, 0.85) !important;
        cursor: pointer !important;
      }
    }
  `,
  host: {
    class: 'flex justify-center !cursor-pointer',
    '(click)': 'close()',
  },
})
export class ImageOverlayContentComponent {
  readonly #overlayRef = inject(OverlayRef);

  readonly url = signal<string | null>(null);
  readonly alt = signal<string | null>(null);
  readonly fileName = signal<string | null>(null);
  readonly fileSize = signal<number | null>(null);
  readonly file = signal<File | null>(null);

  protected readonly effectiveFileName = computed(
    () => this.fileName() ?? this.file()?.name ?? 'Unknown',
  );
  protected readonly effectiveAlt = computed(() => this.alt() ?? this.effectiveFileName());
  protected readonly effectiveFileSize = computed(
    () => this.fileSize() ?? this.file()?.size ?? null,
  );

  protected readonly effectiveUrl = computed(() => {
    const url = this.url();
    if (isString(url)) {
      return url;
    }
    const file = this.file();
    if (file === null) {
      throw new Error('File is null');
    }
    if (!file.type.startsWith('image/')) {
      throw new Error('File is not an image');
    }
    return URL.createObjectURL(file);
  });

  protected close(): void {
    this.#overlayRef.dispose();
  }
}
